import apiClient from './client'
import type { SettingsTemplate, CreateSettingsTemplateDto, UpdateSettingsTemplateDto, SettingsTemplateType } from '@/types/settings-template'

export const settingsTemplatesApi = {
  list: async (options?: {
    type?: SettingsTemplateType
    scriptId?: string
  }): Promise<SettingsTemplate[]> => {
    const params = new URLSearchParams()
    if (options?.type) params.append('type', options.type)
    if (options?.scriptId) params.append('scriptId', options.scriptId)
    
    const response = await apiClient.get(`/settings-templates?${params.toString()}`)
    // Backend returns { success: true, data: templates[] }
    const templates = response.data?.data || response.data?.templates || response.data || []
    return Array.isArray(templates) ? templates : []
  },

  get: async (id: string): Promise<SettingsTemplate> => {
    const response = await apiClient.get(`/settings-templates/${id}`)
    // Backend returns { success: true, data: template }
    return response.data?.data || response.data?.template || response.data
  },

  create: async (data: CreateSettingsTemplateDto): Promise<SettingsTemplate> => {
    const response = await apiClient.post('/settings-templates', data)
    // Backend returns { success: true, data: template }
    return response.data?.data || response.data?.template || response.data
  },

  update: async (id: string, data: UpdateSettingsTemplateDto): Promise<SettingsTemplate> => {
    const response = await apiClient.patch(`/settings-templates/${id}`, data)
    // Backend returns { success: true, data: template }
    return response.data?.data || response.data?.template || response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/settings-templates/${id}`)
  },

  clone: async (id: string, name?: string): Promise<SettingsTemplate> => {
    const response = await apiClient.post(`/settings-templates/${id}/clone`, { name })
    // Backend returns { success: true, data: template }
    return response.data?.data || response.data?.template || response.data
  },

  getByScript: async (scriptId: string): Promise<SettingsTemplate[]> => {
    const response = await apiClient.get(`/settings-templates/script/${scriptId}`)
    // Backend returns { success: true, data: templates[] }
    const templates = response.data?.data || response.data?.templates || response.data || []
    return Array.isArray(templates) ? templates : []
  },
}
